/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */
import { faker } from '@faker-js/faker';
import type { RequestHandlerOptions } from 'msw';
import { delay, HttpResponse, http } from 'msw';

import type {
  GeneralChatThreadDetailResponse,
  GeneralChatThreadListResponse,
  GeneralChatTurnDetailResponse,
  IdResponse,
  SuccessResponse,
} from './model';

export const getListGeneralChatThreadsResponseMock = (): GeneralChatThreadListResponse => ({
  ...{ count: faker.number.int({ min: undefined, max: undefined }) },
  ...{
    items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        id: faker.string.uuid(),
        title: faker.string.alpha({ length: { min: 10, max: 20 } }),
        is_favorite: faker.datatype.boolean(),
        created_at: `${faker.date.past().toISOString().split('.')[0]}Z`,
        updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`,
        last_message_at: faker.helpers.arrayElement([
          faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, null]),
          undefined,
        ]),
      }),
    ),
  },
});

export const getCreateGeneralChatThreadResponseMock = (): IdResponse => ({
  id: '00000001-0000-0000-0000-000000000001',
});

export const getGetGeneralChatThreadResponseMock = (
  overrideResponse: Partial<GeneralChatThreadDetailResponse> = {},
): GeneralChatThreadDetailResponse => ({
  id: faker.string.uuid(),
  title: faker.string.alpha({ length: { min: 10, max: 20 } }),
  is_favorite: faker.datatype.boolean(),
  created_at: `${faker.date.past().toISOString().split('.')[0]}Z`,
  turns: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
    id: faker.string.uuid(),
    user_prompt: faker.string.alpha({ length: { min: 10, max: 20 } }),
    completion: faker.string.alpha({ length: { min: 10, max: 20 } }),
    status: faker.helpers.arrayElement([
      'idle',
      'generating',
      'completed',
      'failed',
      'deleted',
    ] as const),
    reference_chat_type: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), null]),
      undefined,
    ]),
    created_at: `${faker.date.past().toISOString().split('.')[0]}Z`,
    documents: faker.helpers.arrayElement([
      Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
        record_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
        record_content: faker.string.alpha({ length: { min: 10, max: 20 } }),
      })),
      undefined,
    ]),
  })),
  ...overrideResponse,
});

export const getUpdateGeneralChatThreadResponseMock = (): SuccessResponse => ({ success: true });

export const getDeleteGeneralChatThreadResponseMock = (): SuccessResponse => ({ success: true });

export const getToggleGeneralChatThreadFavoriteResponseMock = (): SuccessResponse => ({
  success: true,
});

export const getCreateGeneralChatTurnResponseMock = (): IdResponse => ({
  id: '00000001-0000-0000-0000-000000000002',
});

export const getGetGeneralChatTurnResponseMock = (): GeneralChatTurnDetailResponse => ({
  ...{
    id: faker.string.uuid(),
    user_prompt: faker.string.alpha({ length: { min: 10, max: 20 } }),
    completion: faker.string.alpha({ length: { min: 10, max: 20 } }),
    status: faker.helpers.arrayElement([
      'idle',
      'generating',
      'completed',
      'failed',
      'deleted',
    ] as const),
    reference_chat_type: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), null]),
      undefined,
    ]),
    created_at: `${faker.date.past().toISOString().split('.')[0]}Z`,
    documents: faker.helpers.arrayElement([
      Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
        record_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
        record_content: faker.string.alpha({ length: { min: 10, max: 20 } }),
      })),
      undefined,
    ]),
  },
  ...{
    documents: faker.helpers.arrayElement([
      Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
        record_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
        record_content: faker.string.alpha({ length: { min: 10, max: 20 } }),
      })),
      undefined,
    ]),
  },
});

export const getListGeneralChatThreadsMockHandler = (
  overrideResponse?:
    | GeneralChatThreadListResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<GeneralChatThreadListResponse> | GeneralChatThreadListResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/general-chat-threads',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getListGeneralChatThreadsResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getCreateGeneralChatThreadMockHandler = (
  overrideResponse?:
    | IdResponse
    | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<IdResponse> | IdResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/general-chat-threads',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCreateGeneralChatThreadResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetGeneralChatThreadMockHandler = (
  overrideResponse?:
    | GeneralChatThreadDetailResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<GeneralChatThreadDetailResponse> | GeneralChatThreadDetailResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/general-chat-threads/:threadId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetGeneralChatThreadResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getUpdateGeneralChatThreadMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.patch>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.patch(
    '*/general-chat-threads/:threadId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getUpdateGeneralChatThreadResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getDeleteGeneralChatThreadMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.delete(
    '*/general-chat-threads/:threadId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getDeleteGeneralChatThreadResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getToggleGeneralChatThreadFavoriteMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.patch>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.patch(
    '*/general-chat-threads/:threadId/favorite',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getToggleGeneralChatThreadFavoriteResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getCreateGeneralChatTurnMockHandler = (
  overrideResponse?:
    | IdResponse
    | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<IdResponse> | IdResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/general-chat-threads/:threadId/turns',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCreateGeneralChatTurnResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetGeneralChatTurnMockHandler = (
  overrideResponse?:
    | GeneralChatTurnDetailResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<GeneralChatTurnDetailResponse> | GeneralChatTurnDetailResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/general-chat-threads/:threadId/turns/:turnId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetGeneralChatTurnResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};
export const getDnRAPIMock = () => [
  getListGeneralChatThreadsMockHandler(),
  getCreateGeneralChatThreadMockHandler(),
  getGetGeneralChatThreadMockHandler(),
  getUpdateGeneralChatThreadMockHandler(),
  getDeleteGeneralChatThreadMockHandler(),
  getToggleGeneralChatThreadFavoriteMockHandler(),
  getCreateGeneralChatTurnMockHandler(),
  getGetGeneralChatTurnMockHandler(),
];
